function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useRef, useMemo, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { IconButton } from '@cbhq/cds-web/buttons/IconButton';
import { Divider } from '@cbhq/cds-web/layout/Divider';
import { palette } from '@cbhq/cds-web/tokens';
import { useCanonicalUrl, useClickOutside, useOnScroll, Div, EditorialArticleNavigationSelect, SlideIn, Text, ShareLinks, useInView, SlideInOut } from '@cbhq/cdx-components';
import { useContentfulMicrocopy } from '../../../globals/microcopy.js';
import { jsx, jsxs } from 'react/jsx-runtime';
function MobileSidebar({
  anchors = [],
  showSocialSharingLinks
}) {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showShareBar = _useState2[0],
    setShowShareBar = _useState2[1];
  const containerRef = useRef(null);
  const canonicalUrl = useCanonicalUrl();
  const microcopies = useContentfulMicrocopy();
  useClickOutside(() => setShowShareBar(false), containerRef, showShareBar);
  useOnScroll({
    onScrollUp: () => setShowShareBar(false),
    onScrollDown: () => setShowShareBar(false),
    disabledDown: !showShareBar,
    disabledUp: !showShareBar
  });
  return /*#__PURE__*/jsx(Div, {
    as: "nav",
    position: "relative",
    ref: containerRef,
    children: /*#__PURE__*/jsxs(MobileSidebarContainer, {
      anchors: anchors,
      children: [/*#__PURE__*/jsx(Div, {
        position: "relative",
        alignItems: "center",
        children: anchors.length > 1 && /*#__PURE__*/jsx(EditorialArticleNavigationSelect, {
          quickScrollContent: anchors,
          children: showSocialSharingLinks && /*#__PURE__*/jsx(IconButton, {
            variant: "primary",
            transparent: !showShareBar,
            name: "share"
            // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
            ,

            onPress: () => setShowShareBar(s => !s)
          })
        })
      }), /*#__PURE__*/jsx(Divider, {}), showSocialSharingLinks && showShareBar && /*#__PURE__*/jsxs(SlideIn, {
        children: [/*#__PURE__*/jsxs(Div, {
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 2,
          spacingVertical: 3,
          spacingHorizontal: 2,
          children: [/*#__PURE__*/jsx(Text, {
            variant: "label1",
            color: "foregroundMuted",
            as: "p",
            children: microcopies.global?.share
          }), canonicalUrl && /*#__PURE__*/jsx(ShareLinks, {
            canonicalUrl: canonicalUrl
          })]
        }), /*#__PURE__*/jsx(Divider, {})]
      })]
    })
  });
}
function MobileSidebarContainer({
  children,
  anchors
}) {
  const ids = useMemo(() => anchors?.map(q => q.anchor), [anchors]);
  const anchorIndexInView = useInView(ids, 20);
  const _useState3 = useState(anchorIndexInView !== -1),
    _useState4 = _slicedToArray(_useState3, 2),
    selectInView = _useState4[0],
    setSelectInView = _useState4[1];
  useEffect(() => {
    setSelectInView(anchorIndexInView !== -1);
  }, [anchorIndexInView]);
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    visible = _useState6[0],
    setVisible = _useState6[1];
  const show = useCallback(() => setVisible(false), []);
  const hide = useCallback(() => setVisible(true), []);
  useOnScroll({
    onScrollUp: show,
    onScrollDown: hide,
    disabledUp: !visible,
    disabledDown: visible
  });
  return /*#__PURE__*/jsx(FullSizeContainer, {
    show: visible && selectInView,
    children: children
  });
}

// eslint-disable-next-line @cbhq/theme-no-static-value -- TODO Fix this
const FullSizeContainer = styled(SlideInOut)`
  z-index: 1;
  background: ${palette.background};

  flex-direction: column;
  position: absolute;
  width: 100vw;

  top: 0;
  height: fit-content;
`;
export { MobileSidebar };
//# sourceMappingURL=MobileSidebar.js.map
